import { Dropdown } from "react-bootstrap";

interface AppointmentActionsDropdownProps {
  name: string;
  options?: { value: string | number; label: string }[];
  value?: string | number;
  onChange?: (value: string | number) => void;
  disabled?: boolean;
  forInvoice?: boolean;
}

const AppointmentActionsDropdown: React.FC<AppointmentActionsDropdownProps> = ({
  name,
  options,
  onChange,
  disabled = false,
  forInvoice = false,
}) => {
  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="primary"
        id="dropdown-actions"
        className="d-flex align-items-center appointment-action-button"
        style={{
          padding: "9px",
          ...(forInvoice && {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          }),
        }}
        disabled={disabled}
      >
        <span className="material-symbols-outlined p-0 me-1">settings </span>
        Actions
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {options?.map((option) => (
          <Dropdown.Item
            key={option.value}
            onClick={() => onChange?.(option.value)}
          >
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AppointmentActionsDropdown;
